import { SnackbarProvider } from 'notistack';
import { snackBarGeneralConfiguration } from 'config';
//redux imports
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { setupStore } from 'store/store.js';
import Notifier from 'components/UI/notifications/Notifier';

import { ThemeProvider } from '@emotion/react';
import { DEFAULT_THEME } from 'utils/themeHelper.js';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { PermissionsProvider } from 'contexts/PermissionsContext';

const TEST_ENVIRONMENT = 'test';

export default function wrapWithProviders(Component, options = {}) {
    const { environment = TEST_ENVIRONMENT, store = setupStore(), inject } = options;
    if (environment !== TEST_ENVIRONMENT) {
        return wrapWithStoreProvider(wrapWithThemeProvider(wrapWithSnackBarProvider(wrapWithLocalizationProvider(Component))), { store });
    }
    return wrapWithRouterProvider(wrapWithStoreProvider(wrapWithThemeProvider(wrapWithSnackBarProvider(Component)), { store, inject }), {
        environment,
    });
}
export const wrapWithStoreProvider = (Component, { store = setupStore(), inject } = {}) => {
    if (inject) store.injector.inject(inject.key, inject.reducer, inject.saga);

    return <Provider store={store}>{Component}</Provider>;
};

export const wrapWithThemeProvider = (Component) => <ThemeProvider theme={DEFAULT_THEME}>{Component}</ThemeProvider>;

export const wrapWithLocalizationProvider = (Component) => <LocalizationProvider dateAdapter={AdapterDateFns}>{Component}</LocalizationProvider>;

export const wrapWithRouterProvider = (Component, { environment = TEST_ENVIRONMENT }) => {
    const RouterProvider = environment === TEST_ENVIRONMENT ? MemoryRouter : BrowserRouter;
    return <RouterProvider>{Component}</RouterProvider>;
};

export const wrapWithSnackBarProvider = (Component) => {
    return (
        <SnackbarProvider
            maxSnack={snackBarGeneralConfiguration.maxSnack}
            autoHideDuration={snackBarGeneralConfiguration.autoHideDuration}
            preventDuplicate={true}
        >
            {Component}
            <Notifier />
        </SnackbarProvider>
    );
};

export const wrapWithPermissionsProvider = (Component) => {
    return <PermissionsProvider>{Component}</PermissionsProvider>;
};
